var canvas: HTMLCanvasElement;
var context: CanvasRenderingContext2D;

// game variables
var gameover = 0;
var middle = {
    x: 100,
    y: 100,
    dir: 2,
    st: 0,
    tcd: 0,
    scd: 0,
    sch: 0,
    sdr: 0,
    coll: 0,
    rec: 0,
    boost: 1
}
var niddle = {
    x: 500,
    y: 300,
    dir: 0,
    st: 0,
    tcd: 0,
    scd: 0,
    sch: 0,
    sdr: 0,
    coll: 0,
    rec: 0,
    boost: 1
}
var r = 100;
var r_pos = r;
var v_r = 100; // pixels per second

type Geschoss = [number,number,number,number];
var liste: Geschoss[] = [];
// system variables
var last_tick_t = 0;
var width: number;
var height: number;
var keyStates: Set<string> = new Set();
var plop = new Audio('plop.wav');
var qiu = new Audio('qiu.wma');

var logo = new Image();
logo.src = "logo.png";

function draw() {
    context.resetTransform();
    context.clearRect(0, 0, width, height);
    console.log("drawing");
    // select color
    //context.fillStyle = `hsl(${hue}, 50%, 50%)`

    // draw polygon/path
    
    //context.translate(middle.x, middle.y);
    //context.rotate(hue / 360 * 2 * Math.PI);
    //context.beginPath();
    //context.moveTo(0, -r);
    //context.lineTo(r_pos, -r_pos);
    //context.lineTo(r, 0);
    //context.lineTo(r_pos, r_pos);
    //context.lineTo(0, r);
    //context.lineTo(-r_pos, r_pos);
    //context.lineTo(-r, 0);
    //context.lineTo(-r_pos, -r_pos);
    //context.fill();

    //context.drawImage(logo, 100, 100);
    if (gameover==1) {
        //Player 1 win
        context.fillStyle = `hsl(${last_tick_t%360}, 50%, 50%)`;
        context.fillText("Player 1 win!", 250, 180);
        context.fillText("Click to restart.", 250, 200);
    }
    if (gameover==2) {
        //Player 2 win
        context.fillStyle = `hsl(${last_tick_t%360}, 50%, 50%)`;
        context.fillText("Player 2 win!", 250, 180);
        context.fillText("Click to restart.", 250, 200);
    }
    if (gameover==0) {
        if (middle.dir%4==0) {
            context.beginPath();
            context.moveTo(middle.x, middle.y-10);
            context.lineTo(middle.x+10, middle.y);
            context.lineTo(middle.x+10, middle.y+10);
            context.lineTo(middle.x, middle.y);
            context.lineTo(middle.x-10, middle.y+10);
            context.lineTo(middle.x-10, middle.y);
            context.lineTo(middle.x, middle.y-10);
            context.fillStyle = `hsl(${middle.st*120}, 50%, 50%)`;
            context.fill();
        }
        if (middle.dir%4==1) {
            context.beginPath();
            context.moveTo(middle.x+10, middle.y);
            context.lineTo(middle.x, middle.y+10);
            context.lineTo(middle.x-10, middle.y+10);
            context.lineTo(middle.x, middle.y);
            context.lineTo(middle.x-10, middle.y-10);
            context.lineTo(middle.x, middle.y-10);
            context.lineTo(middle.x+10, middle.y);
            context.fillStyle = `hsl(${middle.st*120}, 50%, 50%)`;
            context.fill();
        }
        if (middle.dir%4==2) {
            context.beginPath();
            context.moveTo(middle.x, middle.y+10);
            context.lineTo(middle.x-10, middle.y);
            context.lineTo(middle.x-10, middle.y-10);
            context.lineTo(middle.x, middle.y);
            context.lineTo(middle.x+10, middle.y-10);
            context.lineTo(middle.x+10, middle.y);
            context.lineTo(middle.x, middle.y+10);
            context.fillStyle = `hsl(${middle.st*120}, 50%, 50%)`;
            context.fill();
        }
        if (middle.dir%4==3) {
            context.beginPath();
            context.moveTo(middle.x-10, middle.y);
            context.lineTo(middle.x, middle.y-10);
            context.lineTo(middle.x+10, middle.y-10);
            context.lineTo(middle.x, middle.y);
            context.lineTo(middle.x+10, middle.y+10);
            context.lineTo(middle.x, middle.y+10);
            context.lineTo(middle.x-10, middle.y);
            context.fillStyle = `hsl(${middle.st*120}, 50%, 50%)`;
            context.fill();
        }
    
        switch(niddle.dir%4) {
            case 0:
                context.beginPath();
                context.moveTo(niddle.x, niddle.y-10);
                context.lineTo(niddle.x+10, niddle.y);
                context.lineTo(niddle.x+10, niddle.y+10);
                context.lineTo(niddle.x, niddle.y);
                context.lineTo(niddle.x-10, niddle.y+10);
                context.lineTo(niddle.x-10, niddle.y);
                context.lineTo(niddle.x, niddle.y-10);
                context.fillStyle = `hsl(${niddle.st*120}, 50%, 50%)`;
                context.fill();
                break;
            case 1:
                context.beginPath();
                context.moveTo(niddle.x+10, niddle.y);
                context.lineTo(niddle.x, niddle.y+10);
                context.lineTo(niddle.x-10, niddle.y+10);
                context.lineTo(niddle.x, niddle.y);
                context.lineTo(niddle.x-10, niddle.y-10);
                context.lineTo(niddle.x, niddle.y-10);
                context.lineTo(niddle.x+10, niddle.y);
                context.fillStyle = `hsl(${niddle.st*120}, 50%, 50%)`;
                context.fill();
                break;
            case 2:
                context.beginPath();
                context.moveTo(niddle.x, niddle.y+10);
                context.lineTo(niddle.x-10, niddle.y);
                context.lineTo(niddle.x-10, niddle.y-10);
                context.lineTo(niddle.x, niddle.y);
                context.lineTo(niddle.x+10, niddle.y-10);
                context.lineTo(niddle.x+10, niddle.y);
                context.lineTo(niddle.x, niddle.y+10);
                context.fillStyle = `hsl(${niddle.st*120}, 50%, 50%)`;
                context.fill();
                break;
            case 3:
                context.beginPath();
                context.moveTo(niddle.x-10, niddle.y);
                context.lineTo(niddle.x, niddle.y-10);
                context.lineTo(niddle.x+10, niddle.y-10);
                context.lineTo(niddle.x, niddle.y);
                context.lineTo(niddle.x+10, niddle.y+10);
                context.lineTo(niddle.x, niddle.y+10);
                context.lineTo(niddle.x-10, niddle.y);
                context.fillStyle = `hsl(${niddle.st*120}, 50%, 50%)`;
                context.fill();
                break;
            default: console.log(niddle.dir);
        }
        //obstacles
        context.beginPath();
        context.moveTo(0,0);
        context.lineTo(0,400);
        context.lineTo(600,400);
        context.lineTo(600,0);
        context.lineTo(0,0);
        context.stroke();

    
        context.beginPath();
        context.moveTo(150,50);
        context.lineTo(160,50);
        context.lineTo(160,150);
        context.lineTo(150,150);
        context.lineTo(150,50);
        context.stroke();
    
        context.beginPath();
        context.moveTo(450,350);
        context.lineTo(440,350);
        context.lineTo(440,250);
        context.lineTo(450,250);
        context.lineTo(450,350);
        context.stroke();

        context.beginPath();
        context.moveTo(100,250);
        context.lineTo(250,250);
        context.lineTo(250,260);
        context.lineTo(100,260);
        context.lineTo(100,250);
        context.stroke();

        context.beginPath();
        context.moveTo(350,140);
        context.lineTo(500,140);
        context.lineTo(500,150);
        context.lineTo(350,150);
        context.lineTo(350,140);
        context.stroke();
    
    //Geschosse malen
        for (let i=0 ;i<liste.length;i+=1) {
            context.beginPath();
            context.moveTo(liste[i][0]-4,liste[i][1]-4);
            context.lineTo(liste[i][0]+4,liste[i][1]-4);
            context.lineTo(liste[i][0]+4,liste[i][1]+4);
            context.lineTo(liste[i][0]-4,liste[i][1]+4);
            context.lineTo(liste[i][0]-4,liste[i][1]-4);
            context.fillStyle = `hsl(${60}, 50%, 50%)`;
            context.fill();
        }
    }
}

function update(dt: number) {
    
    //Kollisionsabfrage Player-Obstacle
    if ((middle.x<10) || (middle.x>590) || (middle.y<10) || (middle.y>390) || (140<middle.x&&middle.x<170 && 40<middle.y&&middle.y<160) || (430<middle.x&&middle.x<460 && 240<middle.y&&middle.y<360) || (90<middle.x&&middle.x<260&&240<middle.y&&middle.y<270) || (340<middle.x&&middle.x<510&&130<middle.y&&middle.y<160)) {
        middle.coll=1;
    }
    if (niddle.x<10 || niddle.x>590 || niddle.y<10 || niddle.y>390 || (140<niddle.x&&niddle.x<170 && 40<niddle.y&&niddle.y<160) || (430<niddle.x&&niddle.x<460 && 240<niddle.y&&niddle.y<360) || (90<niddle.x&&niddle.x<260&&240<niddle.y&&niddle.y<270) || (340<niddle.x&&niddle.x<510&&130<niddle.y&&niddle.y<160)) {
        niddle.coll=1;
    }
    //Kollisionsabfrage Geschosse-Player
    
    for (let i=0; i<liste.length; i+=1) {
        if (middle.x-14<liste[i][0]&&liste[i][0]<middle.x+14&&middle.y-14<liste[i][1]&&liste[i][1]<middle.y+14) {
            middle.coll=1;
            liste.splice(i,1);
        }
    }
    for (let i=0; i<liste.length; i+=1) {
        if (niddle.x-14<liste[i][0]&&liste[i][0]<niddle.x+14&&niddle.y-14<liste[i][1]&&liste[i][1]<niddle.y+14) {
            niddle.coll=1;
            liste.splice(i,1);
        }
    }

    //Kollisionsabfrage Geschosse-Obstacle
    for (let i=0; i<liste.length; i+=1) {
        if (liste[i][0]<4 || liste[i][0]>596 || liste[i][1]<4 || liste[i][1]>396 || (146<liste[i][0]&&liste[i][0]<164&&46<liste[i][1]&&liste[i][1]<154) || (436<liste[i][0]&&liste[i][0]<454&&246<liste[i][1]&&liste[i][1]<354) || (96<liste[i][0]&&liste[i][0]<254&&246<liste[i][1]&&liste[i][1]<264) || (346<liste[i][0]&&liste[i][0]<504&&136<liste[i][1]&&liste[i][1]<154)) {
            liste.splice(i,1);
        }
    }
    //Abwicklung Kollision
    if (middle.coll==1) {
        if (middle.sch==1) {
            middle.sch=0;
            middle.sdr=20;
            plop.play();
        }
        if (middle.sdr==0) {
            gameover=2
        }
        middle.coll=0;
    }
    if (niddle.coll==1) {
        if (niddle.sch==1) {
            niddle.sch=0;
            niddle.sdr=20;
            plop.play();
        }
        if (niddle.sdr==0) {
            gameover=1
        }
        niddle.coll=0;
    }
    if (middle.sdr>0) {
        middle.sdr-=1;
    }
    if (niddle.sdr>0) {
        niddle.sdr-=1;
    }

    //Bewegung der Spieler

    if (keyStates.has("a") && middle.tcd==0) {
        middle.tcd=20;
        middle.dir+=3;
    }
    if (keyStates.has("d") && middle.tcd==0) {
        middle.tcd=20;
        middle.dir+=1;
    }
    if (keyStates.has("s") && middle.scd==0) {
        middle.scd = 100;
        middle.st+=2;
        if (middle.st%3==0) {
            middle.boost=1;
        }
        if (middle.st%3==2) {
            middle.sch=1;
            middle.boost=0;
        }
        if (middle.st%3==1) {
            middle.sch=0;
        }
    }
    if (keyStates.has(" ") && middle.rec==0) {
        middle.rec=30;
        qiu.play();
        if (middle.dir%4==0) {
            liste.push([middle.x,middle.y-15,0,200+100*middle.boost])
        }
        if (middle.dir%4==1) {
            liste.push([middle.x+15,middle.y,1,200+100*middle.boost])
        }
        if (middle.dir%4==2) {
            liste.push([middle.x,middle.y+15,2,200+100*middle.boost])
        }
        if (middle.dir%4==3) {
            liste.push([middle.x-15,middle.y,3,200+100*middle.boost])
        }
    }
    if(middle.rec>0) {
        middle.rec-=1;
    }
    if ((keyStates.has("0") || keyStates.has("Insert")) && niddle.rec==0) {
        niddle.rec=30;
        qiu.play();
        if (niddle.dir%4==0) {
            liste.push([niddle.x,niddle.y-15,0,200+100*niddle.boost])
        }
        if (niddle.dir%4==1) {
            liste.push([niddle.x+15,niddle.y,1,200+100*niddle.boost])
        }
        if (niddle.dir%4==2) {
            liste.push([niddle.x,niddle.y+15,2,200+100*niddle.boost])
        }
        if (niddle.dir%4==3) {
            liste.push([niddle.x-15,niddle.y,3,200+100*niddle.boost])
        }
    }
    if(niddle.rec>0) {
        niddle.rec-=1;
    }
    if (middle.scd>0) {
        middle.scd-=1;
    }
    if (middle.tcd>0) {
        middle.tcd-=1;
    }
    if (keyStates.has("w")) {
        if (middle.dir%4==0) {
            middle.y-=100 * dt;
            if (middle.st%3==1) {
                middle.y-=20*dt;
            }
        }
        if (middle.dir%4==1) {
            middle.x+=100 * dt;
            if (middle.st%3==1) {
                middle.x+=20*dt;
            }
        }
        if (middle.dir%4==2) {
            middle.y+=100 * dt;
            if (middle.st%3==1) {
                middle.y+=20*dt;
            }
        }
        if (middle.dir%4==3) {
            middle.x-=100 * dt;
            if (middle.st%3==1) {
                middle.x-=20*dt;
            }
        }
    }    
    if (keyStates.has("ArrowLeft") && niddle.tcd==0) {
        niddle.tcd=20;
        niddle.dir+=3;
    }
    if (keyStates.has("ArrowRight") && niddle.tcd==0) {
        niddle.tcd=20;
        niddle.dir+=1;
    }
    if (niddle.tcd>0) {
        niddle.tcd-=1;
    }
    if (keyStates.has("ArrowDown") && niddle.scd==0) {
        niddle.scd = 100;
        niddle.st+=2;
        if (niddle.st%3==0) {
            niddle.boost=1
        }
        if (niddle.st%3==2) {
            niddle.sch=1;
            niddle.boost=0;
        }
        if (niddle.st%3==1) {
            niddle.sch=0;
        }
    }
    if (niddle.scd>0) {
        niddle.scd-=1;
    }
    if (keyStates.has("ArrowUp")) {
        if (niddle.dir%4==0) {
            niddle.y-=100 * dt;
            if (niddle.st%3==1) {
                niddle.y-=20*dt;
            }
            console.log(niddle.x, niddle.y);
        }
        if (niddle.dir%4==1) {
            niddle.x+=100 * dt;
            if (niddle.st%3==1) {
                niddle.x+=20*dt;
            }
            console.log(niddle.x, niddle.y);
        }
        if (niddle.dir%4==2) {
            niddle.y+=100 * dt;
            if (niddle.st%3==1) {
                niddle.y+=20*dt;
            }
            console.log(niddle.x, niddle.y);
        }
        if (niddle.dir%4==3) {
            niddle.x-=100 * dt;
            if (niddle.st%3==1) {
                niddle.x-=20*dt;
            }
            console.log(niddle.x, niddle.y);
        }
    }  

    // Bewegung der Geschosse
    for (let i=0 ; i<liste.length; i+=1) {
        if (liste[i][2]==0) {
            liste[i][1]-=liste[i][3]*dt;
        }
        if (liste[i][2]==1) {
            liste[i][0]+=liste[i][3]*dt;
        }
        if (liste[i][2]==2) {
            liste[i][1]+=liste[i][3]*dt;
        }
        if (liste[i][2]==3) {
            liste[i][0]-=liste[i][3]*dt;
        }
    }



    //if (keyStates.has("ArrowUp")) {
        // position
    //    middle.x += 200 * dt;
    //    middle.y += 200 * dt;
    //    if (middle.x > width) {
    //        plop.play();
    //        middle.x = 0;
    //    }
    //    if (middle.y > height) {
    //        plop.play();
    //        middle.y = 0;
    //    }
    //}
}

function loop(t_ms: number) {
    // calculate dt
    let dt = t_ms - last_tick_t;
    last_tick_t = t_ms;
    update(dt / 1000); // to seconds
    draw();
    window.requestAnimationFrame(loop);
}

function resized() {
    //width = window.innerWidth;
    //height = window.innerHeight;
    width=600
    height=400
    canvas.width = width;
    canvas.height = height;
}

function key(e: KeyboardEvent) {
    console.log(keyStates);
    switch (e.type) {
        case "keydown":
            console.log(e.key);
            keyStates.add(e.key);
            break;
        case "keyup":
            keyStates.delete(e.key);
            break;
        default:
            console.warn("Wut?");
    }
}

function click(e: MouseEvent) {
    gameover = 0;
    middle.x=100;
    middle.y=100;
    middle.dir=2;
    middle.st=0;
    middle.coll=0;
    middle.scd=0;
    middle.rec=0;
    middle.boost=1;
    middle.scd=0;
    middle.sdr=0;
    middle.sch=0;
    middle.tcd=0;
    niddle.x=500;
    niddle.y=300;
    niddle.dir=0;
    niddle.st=0;
    niddle.coll=0;
    niddle.scd=0;
    niddle.rec=0;
    niddle.boost=1;
    niddle.scd=0;
    niddle.sdr=0;
    niddle.sch=0;
    niddle.tcd=0;
    liste = [];
}

function main() {
    canvas = document.getElementById("canvas") as HTMLCanvasElement;
    context = canvas.getContext("2d")!;
    window.addEventListener("keydown", key);
    window.addEventListener("keyup", key);
    window.addEventListener("resize", resized);
    canvas.addEventListener("click", click);
    resized();

    loop(performance.now());
}


main();